import { render, staticRenderFns } from "./ManageDepartmentUsersModal.vue?vue&type=template&id=3b525707&"
import script from "./ManageDepartmentUsersModal.vue?vue&type=script&lang=ts&"
export * from "./ManageDepartmentUsersModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports